export default __webpack_public_path__ + "static/media/bg_leafTint_3_t.97d5343a.png";